module.exports = "https://web-assets.ifttt.com/packs/media/perks/subway-8c552bc1.svg";